import * as React from "react";
import Breadcrumb from "../components/breadcrumb";
import Layout from "../layout/layout";
export default class PrivacyPolicy extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let NavList = [
            { Text: 'Privacy Policy', Link: '' }
        ];
        return (React.createElement(Layout, null,
            React.createElement("div", { className: "privacy-policy" },
                React.createElement(Breadcrumb, { NavList: NavList }),
                React.createElement("h5", null, "What We Collect and How We Use Your Data"),
                React.createElement("h1", null, "Privacy Policy"),
                React.createElement("div", { className: "privacy-content" },
                    React.createElement("h3", null, "What We Collect and Why"),
                    React.createElement("p", null,
                        "Both ",
                        React.createElement("a", { href: "www.liquorconnect.com" }, "www.liquorconnect.com"),
                        " and the android and ios mobile Liquor Connect apps make use of third party login providers (Facebook, Google) to enable creating and managing a list of preferred products. The only information gathered to this end is the user\u2019s email for the login itself and a reference tying that user to those selected products for their list. ",
                        React.createElement("b", null, "No other information is tracked, used nor stored."),
                        " Upon deletion of the user\u2019s account (as per below) all this information is fully removed from the system."),
                    React.createElement("h3", null, "How to Delete Your Account and Related Data - From Within the Mobile Apps"),
                    React.createElement("p", null, "From within the mobile app users can delete their data by clicking on the link to do so on the bottom of the logout dialog."),
                    React.createElement("p", null,
                        React.createElement("img", { src: "/img/removeinfoinapp.png", alt: "remove information from app logout screenscreenshot" }),
                        React.createElement("br", null),
                        "(image taken in Liquor Connect app on android)"),
                    React.createElement("h3", null, "How to Delete Your Account and Related Data - No App Access"),
                    React.createElement("p", null, "Both Facebook and Google allow users to remove their information via their systems by navigating to their app management pages directly. From there, locate the entry marked \"Liquor Connect\" and click \"Remove.\" The locations for those app listings are, respectively:"),
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            "Google: ",
                            React.createElement("a", { href: "https://myaccount.google.com/permissions" }, "https://myaccount.google.com/permissions")),
                        React.createElement("li", null,
                            "Facebook: ",
                            React.createElement("a", { href: "https://www.facebook.com/settings?tab=applications&ref=settings" }, "https://www.facebook.com/settings?tab=applications&ref=settings"))),
                    React.createElement("p", null)))));
    }
}
;
//# sourceMappingURL=privacy-policy.js.map